import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MergeTagDto } from "../../../../../../api/src/creative-unit-package/models/merge-tag/merge-tag.dto";

export interface MergeTagState extends EntityState<MergeTagDto> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({
	name: 'merge-tag',
	resettable: true
})
export class MergeTagStore extends EntityStore<MergeTagState> {
	constructor() {
		super();
	}
}
